import styled from "styled-components";

export const Container = styled.div`
	position: fixed;
	top: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	z-index: 999;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const ContainerLoading = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 20px;
	border-radius: 10px;
`;
